/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Confirmation_AutonomousInputs */



/**
* | output |
* | --- |
* | "Acts on its own" |
*
* @param {Agent_Builder_Confirmation_AutonomousInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_confirmation_autonomous = /** @type {((inputs?: Agent_Builder_Confirmation_AutonomousInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Confirmation_AutonomousInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Handelt selbstständig")
	return /** @type {LocalizedString} */ ("Acts on its own")
});